import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { StreetAndNumber } from '../../Zemplin/Form/StreetAndNumber';
import { CityZip } from '../../Zemplin/Form/CityZip';
import { DsiAddress as Address } from '../Form/Address';
import { StyledInput } from '../Auth/WarehouseRegisterForm';
import { StyledLabel } from '../Auth/LoginForm';
import { Required } from '../Auth/RegisterForm';
import { FormInput } from '../Form/FormInput';
import { Select } from '../General/Select';
import { AccountFormWrapper } from './ContactInfoBlock';
import { FormSelect } from '../Form/FormSelect';
import { phonePrefixes } from '../Cart/utilities';
import { prop } from '../../../utilities';

interface Props {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  country_id: string;
  name: string;
  surname: string;
  company: string;
  delivery_phone: string;
  delivery_phone_prefix: string;
  delivery_email: string;
  onChange: any;
  isPreffered: boolean;
  isNew: boolean;
  isB2B: boolean;
  lang: string;
  formProblems: any;
}

function AddressChangeForm({
  street,
  streetNumber,
  city,
  zip,
  name,
  surname,
  company,
  delivery_phone,
  delivery_phone_prefix,
  delivery_email,
  country_id,
  isPreffered,
  onChange,
  isNew,
  isB2B,
  lang,
  formProblems,
}: Props) {
  const {
    emailProblem,
    phoneProblem,
    streetProblem,
    streetNumberProblem,
    cityProblem,
    zipProblem,
  } = {
    emailProblem: prop(formProblems, 'person.email'),
    phoneProblem: prop(formProblems, 'person.phone'),
    streetProblem: prop(formProblems, 'street'),
    streetNumberProblem: prop(formProblems, 'street_number'),
    cityProblem: prop(formProblems, 'city'),
    zipProblem: prop(formProblems, 'zip'),
  };

  return (
    <Wrapper>
      <Title>
        {isB2B
          ? __('Dodacia adresa')
          : isNew
          ? __('Pridať novú adresu')
          : __('Upraviť adresu')}
      </Title>

      <NameRow isB2B={true}>
        {(!company || !isB2B) && (
          <StyledInput marginRight={16}>
            <FormInput
              justText={isB2B}
              name={'name'}
              type="text"
              label={!isB2B ? __('Meno') : __('Meno a priezvisko')}
              value={name}
              marginRight={16}
              onChange={onChange}
            />
          </StyledInput>
        )}
        {!isB2B && (
          <StyledInput>
            <FormInput
              name={'surname'}
              type="text"
              label={__('Priezvisko')}
              value={surname}
              marginBottom={16}
              onChange={onChange}
            />
          </StyledInput>
        )}
      </NameRow>
      {(!!company || !isB2B) && (
        <StyledInput marginBottom={24}>
          <FormInput
            justText={isB2B}
            label={__('Firma')}
            name={'company'}
            type="text"
            value={company}
            marginBottom={0}
            onChange={onChange}
          />
        </StyledInput>
      )}
      <Address
        street={street}
        streetNumber={streetNumber}
        city={city}
        zip={zip}
        onChange={onChange}
        isB2B={isB2B}
        formProblems={{
          streetProblem,
          streetNumberProblem,
          cityProblem,
          zipProblem,
        }}
      />
      {/* <StyledLabel htmlFor="country_id" marginBottom={8}>
        {`${__('Krajina')}`}
        <Required>{`*`}</Required>
      </StyledLabel> */}
      <Select
        justText={isB2B}
        marginBottom={24}
        label={`${__('Krajina')}`}
        name="country_id"
        value={country_id}
        options={
          lang === 'cz'
            ? [{ value: 'cz', name: __('Česká republika') }]
            : [{ value: 'sk', name: 'Slovensko' }]
        }
        // tslint:disable-next-line:jsx-no-lambda
        onChange={onChange}
        backgroundColor={'#FFFFFF'}
      />

      {/* {(!!delivery_phone || !isB2B) && (
        <StyledInput marginBottom={24}>
          <FormInput
            justText={isB2B}
            label={__('Kontaktné tel. číslo')}
            name={'delivery_phone'}
            // required={true}
            type="text"
            value={delivery_phone}
            marginBottom={0}
            onChange={onChange}
          />
        </StyledInput>
      )} */}
      {(!!delivery_phone || !isB2B) && (
        <AccountFormWrapper isB2B={false} noWrap={true} marginRight={32}>
          <FormSelect
            justText={isB2B}
            name="delivery_phone_prefix"
            label={__('Predvoľba')}
            value={delivery_phone_prefix}
            options={phonePrefixes.map(prefix => {
              return { value: prefix, name: prefix };
            })}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={onChange}
            // onBlur={handleBlur}
            marginBottom={16}
            maxWidth={38}
            maxWidthPx={96}
            marginRight={16}
            height={56}
          />
          <FormInput
            justText={isB2B}
            // inputRef={phoneRef}
            name={'delivery_phone'}
            type="text"
            required={true}
            label={__('Tel. číslo')}
            value={delivery_phone}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={onChange}
            // onBlur={handleBlur}
            validMessage={phoneProblem}
            maxWidth={100}
            maxWidthPx={208}
            marginBottom={16}
            autoComplete="tel"
            validateAllowedChars={true}
          />
        </AccountFormWrapper>
      )}
      {(!!delivery_email || !isB2B) && (
        <StyledInput marginBottom={24}>
          <FormInput
            justText={isB2B}
            label={__('Kontaktný email')}
            name={'delivery_email'}
            // required={true}
            type="text"
            value={delivery_email}
            marginBottom={0}
            onChange={onChange}
            validMessage={emailProblem}
          />
        </StyledInput>
      )}
      <CheckBox
        rounded={true}
        selected={isPreffered}
        label={__('Predvolená adresa')}
        name="isDefault"
        onClick={onChange}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin-bottom: ${rem(32)};
`;

const Title = styled.h2`
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  margin: 0;
  margin-bottom: ${rem(32)};
  font-weight: 400;
`;

const NameRow = styled(FlexRowCenterVertical)<{ isB2B?: boolean }>`
  margin-bottom: ${({ isB2B }) => (isB2B ? 0 : rem(16))};
`;

export { AddressChangeForm as DsiAddressChangeForm };
